// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__wLMIi","label":"styles_label___0ge1","icon":"styles_icon__eYRDT"};